import React, { createContext, useContext, useMemo, useState, useCallback } from 'react';

const DesignerUIContext = createContext({
  leftPanelContent: null,
  setLeftPanelContent: () => {}
});

export const DesignerUIProvider = ({ children }) => {
  const [leftPanelContent, setLeftPanelContentState] = useState(null);

  const setLeftPanelContent = useCallback(content => {
    setLeftPanelContentState(content || null);
  }, []);

  const value = useMemo(
    () => ({
      leftPanelContent,
      setLeftPanelContent
    }),
    [leftPanelContent, setLeftPanelContent]
  );

  return <DesignerUIContext.Provider value={value}>{children}</DesignerUIContext.Provider>;
};

export const useDesignerUI = () => useContext(DesignerUIContext);
